var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{staticClass:"disclaimer"},[_c('h3',{staticClass:"title"},[_vm._v("Remember")]),_c('ol',{staticClass:"list list_white-circle"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }